// add class nBrands to an Item Merchandising widget to move all the product tiles into a new container which we can then use with Splide
$(document).ready(() => {
  $('.nBrands').prepend('<div class="nCarousel-brands splide"><div class="splide__track"><div class="splide__list"></div></div></div>');
  $('.nBrands .owl-item:not(.cloned)').each(function () {
    $(this).addClass('splide__slide');
    $(this).closest('.nBrands').find('.splide__list').append(this);
  });
  // hiding the remainder of the carousel with cloned items
  $('.nBrands > section.brandmerchandising-carousel').css('display', 'none');

  $('.nBrands').wrapInner('<div class="container"></div>');

  // uncomment the section below to use the widget title if the carousel needs to have title
  $('.nBrands .brandmerchandising-carousel h3').each(function () {
    $(this).closest('.nBrands').find('.nCarousel-brands').before(this);
  });
});

// pop-up after credit account app form completion
if (document.body.classList.contains('ex-name-creditaccountapplication')) {
  document.addEventListener('contact-form-sent', (e) => {
    $('.creditModal').modal('show');
  }, false);
}
